import { defineStore } from "pinia";
import { computed, nextTick, ref } from "vue";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";
import { useDateTime } from "@/composable/useDateTime";
import { dayjs } from "@/dayjs";

export const useAccessTokenStore = defineStore("accessTokenStore", () => {
    const { dateIsInFuture } = useDateTime();

    const accessToken = ref<string | undefined>();
    const tokenExpiresIn = ref<Date>(new Date());
    const tokenIsValid = computed(() => dateIsInFuture(tokenExpiresIn.value));

    const { write, read, remove } = new StorageHelper(StorageName.AccessToken, false);


    const saveAccessTokenToLocalStorage = (token: string) => {
        write(token);
    };

    const retrieveAccessTokenFromLocalStorage = () => {
        const token = read<string>();

        if (!token) return;

        saveAccessTokenToStore(token);
    };

    const saveAccessTokenToStore = (token: string) => {
        accessToken.value = token;
    };

    const saveAccessToken = async (token: string) => {
        if (!token) return;

        saveAccessTokenToStore(token);
        saveAccessTokenToLocalStorage(token);

        await nextTick();
    };

    const removeAccessTokenFromStore = () => {
        accessToken.value = undefined;
    };

    const removeAccessTokenFromLocalStorage = () => {
        remove();
    };

    const removeAccessToken = () => {
        removeAccessTokenFromLocalStorage();
        removeAccessTokenFromStore();
    };

    const setExpireDate = (date: number) => {
        tokenExpiresIn.value = dayjs.unix(date).toDate();
    };

    return {
        accessToken,
        saveAccessToken,
        removeAccessToken,
        retrieveAccessTokenFromLocalStorage,
        tokenExpiresIn,
        setExpireDate,
        tokenIsValid,
    };
});
